// extracted by mini-css-extract-plugin
module.exports = {"cell":"table-row_cell__2FTqC","deleteCell":"table-row_deleteCell__1-Ays"};